import _ from 'lodash'

// XSTDW Xtract Skin Test Detail Window

const initialState = {
  keyboardPosition: 'right', // does this need to become a stored preference somewhere?
  protocol: {
    columns: []
  },
  extracts: [],
  committedValues: {},
  dirtyValues: {},
  cellErrors: {}
}

/**
 * Sets up placeholder values for all cells in the skintest score table
 * @param {Object} state
 */
const updateStateExtractColumn = state => {
  const columnIds = _.map(state.protocol.columns, 'id')
  const committedValues = { ...state.committedValues }
  const dirtyValues = { ...state.dirtyValues }
  const cellErrors = { ...state.cellErrors }
  // NOTE that this will not delete state data for extracts which are removed
  // TODO create selector that cleans up this data prior to save against API
  state.extracts.forEach(extract => {
    committedValues[extract.id] = _.zipObject(
      columnIds,
      _.map(columnIds, columnId =>
        _.get(committedValues, '[extract.id][columnId]', null)
      )
    )
    dirtyValues[extract.id] = _.zipObject(
      columnIds,
      _.map(columnIds, columnId =>
        _.get(dirtyValues, '[extract.id][columnId]', null)
      )
    )
    cellErrors[extract.id] = _.zipObject(
      columnIds,
      _.map(columnIds, columnId =>
        _.get(cellErrors, '[extract.id][columnId]', null)
      )
    )
  })
  return {
    ...state,
    committedValues,
    dirtyValues,
    cellErrors
  }
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'XSTDW_KEYBOARD_POSITION_SET':
      return {
        ...state,
        keyboardPosition: action.position
      }
    // REMINDER spec says protocol is not allowed to be changed on a skintest
    // after it has been created
    case 'XSTDW_PROTOCOL_SET':
      // NOTE application expects validateProtocol() to be run on protocol
      // prior to dispatching to the store!
      return updateStateExtractColumn({
        ...state,
        protocol: action.protocol
      })
    case 'XSTDW_ANTIGENS_SET':
      return updateStateExtractColumn({
        ...state,
        extracts: action.extracts
      })
    case 'XSTDW_DIRTY_VALUE_SET':
      return {
        ...state,
        dirtyValues: {
          ...state.dirtyValues,
          [action.extractId]: {
            ...state.dirtyValues[action.extractId],
            [action.columnId]: action.value
          }
        }
      }
    case 'XSTDW_CELL_ERROR_SET':
      return {
        ...state,
        cellErrors: {
          ...state.cellErrors,
          [action.extractId]: {
            ...state.cellErrors[action.extractId],
            [action.columnId]: action.value || false
          }
        }
      }
    case 'XSTDW_COMMITTED_VALUES_SET':
      return {
        ...state,
        committedValues: action.committedValues
      }
    default:
      return state
  }
}

export default reducer
